/**
 * Guide topic — Order-share comms. Walks through how preferred accounts are
 * triaged against their order-share benefit tiers, and when a nudge needs
 * rep approval versus sending automatically.
 */

import { GuidePage } from "@/features/guide/guide-page";

export function GuideSharePage() {
  return (
    <GuidePage
      eyebrow="Workflow"
      title="Order-share comms"
      intro="Preferred accounts are triaged each quarter against three benefit tiers — T1 at 30%, T2 at 50%, T3 at 75% of their contact-lens order share. Where an account sits versus its tier decides whether the agent nudges automatically, drafts a nudge for approval, or leaves it alone."
      cta={{ to: "/share", label: "Open order-share comms" }}
      walkthrough={[
        {
          step: "Accounts are triaged against the programme tiers",
          body: "Each quarter, every preferred account's current order share is compared against T1 (30%), T2 (50%), and T3 (75%).",
        },
        {
          step: "Below 75% — the agent nudges automatically",
          body: "Accounts trending below the top tier get an automatic reminder email, with no rep review needed.",
        },
        {
          step: "75–79% — a rep approves before it sends",
          body: "Accounts close to the top tier get a drafted nudge that waits in the queue until a rep reviews and approves it.",
        },
        {
          step: "80% and above — left alone",
          body: "Accounts already at or above the top tier don't need a nudge; the agent leaves them alone and moves on.",
        },
      ]}
    />
  );
}
